export const getIsNorthAmericanCountryCode = (
  countryCode: string | undefined,
) => ['us', 'ca'].includes(countryCode ?? '');
